import UniversityRepository, {
    Part,
    UniversityPart
} from '../../../networking/repos/UniversityRepository';
import {PaginationQueryConfig, SingleQueryConfig} from '../Types';
import {UniversityIndexResponse} from '../../../networking/responses/University';
import {
    UniversityIndexRequest,
    UniversitySearchRequest,
    UniversitySubjectsRequest
} from '../../../networking/requests/University';
import {usePaginationQueryConfig, useQueryConfig} from '../Utils';
import {UniversityQueryKey} from './Key';

export interface UniversityParts {
    program: UniversityPart[];
    // services: UniversityPart[];
    experiences: UniversityPart[];
}

export const useUniversityIndexQueryConfig = (filters: UniversityIndexRequest) => {
    const repo = new UniversityRepository();

    return usePaginationQueryConfig(
        (page) => UniversityQueryKey.index({ ...filters, page }),
        (page) => repo.filter({ ...filters, page })
    );
};

export const useUniversitySearchQueryConfig = (request: UniversitySearchRequest): PaginationQueryConfig<UniversityIndexResponse> => {
    const repo = new UniversityRepository();

    return usePaginationQueryConfig(
        (page) => UniversityQueryKey.search({ ...request, page }),
        (page) => repo.search({ ...request, page })
    );
};

export const useUniversityDetailQueryConfig = (universityId: number) => {
    const repo = new UniversityRepository();

    return useQueryConfig(UniversityQueryKey.detail(universityId), () => repo.find(universityId));
};

export const useUniversityFindQueryConfig = (universityIds: number[]) => {
    const repo = new UniversityRepository();

    return useQueryConfig(UniversityQueryKey.find(universityIds), () => repo.findAll(universityIds));
};

export const useUniversitySubjectsQueryConfig = (universityId: number, request: UniversitySubjectsRequest) => {
    const repo = new UniversityRepository();

    return usePaginationQueryConfig(
        (page) => UniversityQueryKey.subjects({ universityId, page, ...request }),
        (page) => repo.subjects(universityId, { ...request, page })
    );
};

export const useUniversityCostsQueryConfig = (universityId: number) => {
    const repo = new UniversityRepository();

    return useQueryConfig(UniversityQueryKey.costs(universityId), () => repo.withCosts(universityId, Part.GENERAL));
};

export const useUniversityPartsQueryConfig = (universityId: number): SingleQueryConfig<UniversityParts> => {
    const repo = new UniversityRepository();

    return useQueryConfig(
        UniversityQueryKey.parts(universityId),
        async () => {
            const data = await Promise.all([
                repo.withParts(universityId, Part.PROGRAM),
                // repo.withParts(universityId, Part.SERVICES),
                repo.withParts(universityId, Part.EXPERIENCES)
            ]);

            return {
                program: data[0],
                // services: data[1],
                experiences: data[1], // change 1 to 2 when services is uncommented
            };
        }
    );
};
